export const isInternalNavigationEnabled = (mode) =>
  mode !== "documentPortal";

export const getInternalNavigationLayout = ({
  mode,
  isWideScreen,
  isDrawerOpen,
}) => {
  const isEnabled = isInternalNavigationEnabled(mode);
  const isOpen = isEnabled && isDrawerOpen;

  return {
    isEnabled,
    isOpen,
    shouldOffsetContent: isEnabled && isWideScreen && isDrawerOpen,
  };
};
